export default "__VITE_ASSET__zO4eEfc5__"